import script from "./WeChatSearh.vue?vue&type=script&lang=ts&setup=true"
export * from "./WeChatSearh.vue?vue&type=script&lang=ts&setup=true"

import "./WeChatSearh.vue?vue&type=style&index=0&id=65a4dc84&scoped=true&lang=css"

import exportComponent from "/Users/ra1to/Desktop/web_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65a4dc84"]])

export default __exports__